class BoxError extends Error {
  constructor(message) {
      super(message);
      this.name = "BoxError";
      this.statusCode = 400;
  }
}

export default BoxError;
